import el from 'element-ui/lib/locale/lang/en';

/* eslint-disable */
export default {
  app: {
    hi: 'Hi',
    name: 'Okubuy',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    reset_password: 'Reset password',
    default: 'Default',
    create_account: 'Create account',
    delete: 'Delete',
    edit: 'Edit',
    tips: 'Tips',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    view_more: 'More',
    view: 'View',
    share: 'Share',
    submit: 'Submit',
    no_limit: 'No limit',
    file_only_accept_jpg_png: 'File only accept jpg png',
    file_size_only: 'File size only{size}',
    search: 'Search',
    reset: 'Reset',
    select_all: 'Select all',
    inputMoreThanWords: 'The input cannot be less than {0} characters',
    please_login: 'Please login first account',
    submit_err: 'Submit failed',
    delete_err: 'delete failed',
    search_bar_placeholder: 'Enter the item or brand name, search for the entire item',
    loading_captcha: 'Loading verification code...',
    loading: 'Loading...',
    currency: 'currency',
    yes: 'Oui',
    none: 'Non',
  },
  topbar: {
    faq: 'FAQ',
    guide: 'Guide',
    exchange_rate: 'Rate',
  },
  nav: {
    home: 'Home',
    shop: 'Shop',
    forwarding: 'Forwarding',
    more_classify: 'More classify',
    proxy_request: 'Requesting purchasing',
    product_promotion: 'Product introduction',
    straight: 'Our shop',
    proxy_buy: 'Purchasing',
    new_product: 'New products',
    off_price_product: 'Sale',
    hot_sales_product: 'Hot sales',
    recommend_product: 'Recommended',
    free_postage_product: 'Free shipping',
    all_product: 'All',
  },
  faq: {
    most_popular_questions: 'The hottest question',
    account_registration: 'Registered members',
    making_purchase: 'The purchase of goods',
    package: 'Package warehousing and delivery',
    other_questions: 'Other',
    answer_your_questions: 'Does this FAQ answer your questions？',
    thankyou_for_your_feedback: 'Submission successful! Thank you very much for your feedback, we will continue to do better!',
    ask_us: 'No answer yet? Ask us.',
    we_respond_within_2days: 'We usually reply within 2 working days. The hottest questions will appear on this page.',
    subject: 'Theme',
    your_name: 'Name',
    cellphone: 'Cellphone',
    email: 'Email',
    category: 'Category',
    question: 'Question',
    placeholder: {
      name: 'Please fill in your name',
      email: 'Please fill in your email address',
      category: 'Please select the question type',
      question: 'Please fill in your questions',
      subject: 'Please fill in your subject',
      cellphone: 'Please fill in your telephone number',
    },
    rules: {
      name: 'The name cannot be empty',
      email: 'The email address cannot be empty',
      correct_email: 'Please fill in the correct email address',
      category: 'Please select the question type',
      question: 'Questions cannot be left blank',
      question_len: 'Enter at least 3 characters for the problem',
      subject: 'The topic cannot be empty',
    },
  },
  shop_names: {
    rakuten: 'Rakuten',
    yahoo_jp: 'YAHOO!JAPAN',
    amazon_jp: 'Amazon JP',
  },
  login: {
    page_title: 'Login or creat an accout',
    registered: 'registered',
    login_tips: 'If you have an account please log in',
    mobile_authenticated: 'The mobile number is registered?',
    mobile_tips: 'Please enter your mobile number to get SMS verification code login',
    remember_me: 'Remember me',
    forgot_password: 'Forgot password',
    placeholder: {
      account: 'Account or email address',
      password: 'Password',
      mobile: 'Please enter the registered mobile number',
    },
    rules_message: {
      account_required: 'Account or email address',
      password_required: 'Password',
      mobile_required: 'Please enter your mobile number',
      mobile_error: 'Please enter the correct mobile number',
      captcha_required: 'Please enter SMS verification code',
    },
    accountLogin: 'Account login',
    smsLogin: 'SMS verification code login',
    thridPartyLogin: 'Third party login',
    get_sms_captcha: 'Get verification code',
    sms_captcha: 'SMS verification code',
    resend: 'Resend',
    register: 'Registered member',
    un_regisered: 'New to Okubuy?',
    register_tips: 'Registration is free and easy',
    registered_infos: [
      'Faster checkout',
      'Save multiple shipping addresses',
      'View and track orders and more',
    ],
    login_fail: 'Login fail',
  },
  reset: {
    send: 'Send',
    reset: 'Reset password',
    email: 'Email',
    password: 'Password',
    confirm_password: 'Confirm password',
  },
  register: {
    page_title: 'Register',
    register_tips: 'Please enter the following information to create your account',
    accepted: 'Accepted',
    reject: 'Reject',
    read_and_accepted: 'Read and accepted',
    labels: {
      email: 'Email address',
      phone: 'Phone',
      password: 'Password',
      password_confirmation: 'Revent',
      referral_code: 'Introducer',
    },
    placeholder: {
      email: 'Email',
      phone: 'Phone',
      password: 'Passwords must be 6-20 characters',
      password_confirmation: 'Confirm Password',
      referral_code: 'Fill in your referrer membership number, optional',
    },
    rules_message: {
      email_type: 'Enter a valid email address',
      email_required: 'Email address',
      phone_required: 'Phone number',
      password_required: 'Password',
      password_length: 'Passwords must be {min}-{max} characters',
      password_confirmation_required: 'Confirm Password',
      password_not_comfirmed: 'Passwords do no match',
    },
  },
  activation: {
    thank_you_registered: 'Thank you registered{appname}',
    active_your_account: 'Active your account',
    send_mail_tips: 'Verify email address',
    resend_link: 'Resend link',
    activing: 'Activing',
    activation_successed: 'Activation success',
    bind_successed: 'Binding successfully',
    activation_failed: 'Activation failed',
  },
  user: {
    user_center: 'User center',
    my_account: 'My account',
    my_orders: 'My orders',
    product_view_history: 'My view history',
    lately_history: 'Recent history',
    add_recommend: 'Plus purchase discount',
    lately_orders: 'Recent order',
    not_lately_orders: 'No new orders recently',
    not_lately_history: 'No new footprints recently',
    not_lately_wishlist: 'No favorite items',
    not_lately_ship: 'No delivery address added',
    history_err: 'Get my footprint failed',
    information: 'Personal information',
    wish_list: 'My wishlist',
    shipping_address: 'Shipping Address',
    proxy_list: 'Special Request',
    registration_in: 'Registration in',
    last_login_time: 'Last login time',
    coupon: 'My discount coupon',
    coupons: 'Coupon',
    promotion: 'Promotion',
    integral: 'My scores',
    generalize: 'Promotion level',
    member: 'Membership level',
    balance: 'Balance',
    logout: 'Logout',
    order_detail: 'Detail',
    orders_err: 'Get my orders failed',
    go_to_login: 'Login',
    added_to_wishlist: 'Added to wishlist',
    removed_wishlist: 'Has moved out of favorites',
    success: 'Modify successfully',
    screen: 'Classification filter',
    upload_img_err: 'Upload avatar image size can not exceed 2MB!',
    type: 'type',
    content: 'content',
    time_limit: 'the term',
    immediate_use: 'use immediately',
    be_usable: 'be usable',
    used: 'Used',
    expired: 'expired',
    no_coupons: 'No coupons available'
  },
  guide: {
    registered_members: 'Registered members',
    buy: 'How to buy',
    payment: 'Terms of payment',
    charge: 'Other shops of goods charge',
    pay_attention: 'Notes and terms',
    first: {
      one: 'Step 1: registration',
      two: 'Please click on the "Register" link in the upper right corner of the homepage to access the member registration page. Click on Register.',
      three: 'Step 2: Set the user ID, password and fill in the email address',
      four: 'The user ID can be set to an email address or phone number and a valid email address can be filled in to receive the confirmation email.',
      five: 'After setting the user ID, password and email address, click the "Submit" button to submit the membership registration application.',
      six: 'Step 3: Confirm the mail',
      seven: 'After completing the registration, please go to your registered email address to open the email sent to you by OKUBUY and confirm the link to confirm the account. When the email address is confirmed, the registration process for the member account is completed and you can use this account to purchase. If you have not received the email, please check your spam.',
    },
    second: {
      one: 'our shop of OKUBUY',
      two: 'The goods listed in the direct purchase area are all spot goods, which can be sent quickly after purchase. After the payment is completed, if the goods are already in the warehouse, they will be shipped the next day.',
      three: 'If you have other purchasing items that you want to merge and send, you can click "Send to my warehouse" when you choose the shipping method. When the purchase item arrives, it will be shipped together using the combined package function.',
      four: 'Since the goods will enter the purchase process directly after the payment is completed, the order cannot be cancelled unless the goods are out of stock or the price fluctuates. Please confirm the order before purchase.',
      five: 'Once you have found the item you want to purchase, click the "Add to Cart" button.',
      six: 'Confirm the product content and the total amount. If the information is correct, click the "Checkout" button.',
      seven: 'Once you have confirmed your billing address, click the "Continue" button.',
      eight: 'Once you have selected your shipping method, click the Continue button.',
      nine: 'After selecting the payment method and confirming the order content, please click the "Checkout" button to complete the order.',
      ten: 'Once the order is complete, you can check the order details at any time on the order page in My Account. OKUBUY will send you an email to notify you after successfully purchasing your order.',
      eleven: 'Amazon or Ratunen purchasing',
      twelve: 'Just click on the purchase page of "OK Amazon" or "Ratuten Lotte" on the homepage of OKUBUY. Your Amazon/Ratuten basket items will go directly to the OKUBUY shopping basket.',
      thirteen: 'Other website purchasing',
      fourteen: 'OKUBUY can purchase items that can only be purchased on the brand\'s official website or other stores. Please fill out the "Purchasing" form and pay after the order is confirmed.',
      fifteen: 'Since the goods will enter the purchase process directly after the payment is completed, the order cannot be cancelled unless the goods are out of stock or the price fluctuates. Please confirm the order before purchase.',
    },
    third: {
      one: 'payment method',
      two: 'Accept payment by Paypal, Payme, WeChat, Alipay and Bank.',
    },
    fifth: {
      one: 'About goods',
      two: '1. The side of the package (long, wide or high) should not exceed 60cm on either side. If it exceeds 60cm, it must be charged according to the volumetric weight.',
      three: '2. The total length of the package (length, length, height, height, total length) should not exceed 120cm. If it exceeds 120cm, it must be charged according to the volumetric weight.',
      four: 'Delivery Method',
      five: 'After the goods arrive in Hong Kong, the customer will be notified by E-MAIL to pick up the goods (free of charge) or home delivery (additional charge).',
    },
    fourth: {
      Calculation: 'Purchasing commodity charge calculation',
      country: ['','JPN','US','AU','EN & FR & GE','Korea','Thailand','Taiwan'],
      fee: ['Handling fee', '50', '50', '50', '50', '50', '50', '50'],
      internation: ['International shipping (per lb)', '25', '25', '25', '30', '25', '25', '25'],
      local: ['Local freight', 'According to the purchasing website/shop fee standard, the actual sales fee is charged.'],
      price: ['Commodity price', 'Product price & current exchange rate'],
      localPrice: ['Payment fee', '5%', '5%', '5%', '5%', '5%', '5%', '5%'],
    }
  },
  user_info: {
    personal: 'Personal information',
    avatar_image: 'Avatar image',
    login_name: 'Login name',
    update_password: 'Reset password',
    old_password: 'Old password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
    keep: 'Submit',
    actual_name: 'Full name',
    can_only_be_changed_once: 'Login name can only be changed once',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    secrecy: 'Secrecy',
    birthday: 'Birthday',
    choose_birthday: 'Date of birthday',
    phone_number: 'Phone number',
    change_password: 'The password has been modified successfully',
  },
  order: {
    id: 'Order id',
    type: 'Order type',
    quantity: 'Quantity',
    amount: 'Amount',
    status: 'Status',
    order_date: 'Order date',
    subtotal: 'Subtotal',
    name: 'Name',
    price: 'Price',
    size: 'Size',
    color: 'Color',
    shipping: 'Shipping',
    tax: 'Tax',
    sale_tax: 'Sale tax',
    import_tax: 'Import tax',
    total: 'Total',
    total_tax: 'Total tax',
    payment: 'Immediate payment',
    shipping_fee: 'Shipping fee',
    local_shipping_fee: 'Local shipping',
    overseas_shipping_fee: 'Overseas shipping',
    handling_fee: 'Handling fee',
    contains_shipping_fee: 'Contains shipping fee',
    order_detail: 'Order detail',
    created_at: 'Created at',
    cancel_order: 'Cancel order',
    filter_all: 'All order',
    filter_unpaid: 'Pending payment',
    filter_delivered: 'Be delivered',
    filter_shipping: 'In transit',
    filter_uncomment: 'Pending evaluate',
    filter_closed: 'Closed',
    filter_completed: 'Completed',
    filter_wait_for_pickup: 'Pending pickup',
    filter_last_3_months: 'Last 3 months',
    filter_last_6_months: 'Last 6 months',
    filter_input_placeholder: 'Search order id or product name',
    payment_method: 'Payment method',
    payment_status: 'Payment status',
    payment_timeout_tips: 'Payment time out tips',
    wait_for_ship: 'Wait for shipping',
    step1: 'Submit',
    step2: 'Payment successful',
    step3: 'Shipped',
    step4: 'Confirm receipt;',
    step5: 'Evaluate',
    step6: 'Pending payment',
    shipping_info: 'Shipping information',
    shipping_method: 'Shipping method',
    payment_info: 'Payment information',
    products: 'Products',
    total_product: 'Total product',
    total_price: 'Total price',
    order_closed: 'Timeout orders will be automatically closed:',
    successful_payment: 'Successful payment, waiting for the seller to ship',
    shipped: 'The merchant has shipped, please pay attention to the receipt',
    comment: 'The buyer has received the goods, you can evaluate the goods',
    suborder_splited_payment_tips: 'This order belongs to the sub-order of {main_order}, please go to the main order page to make payment, please forgive us for any inconvenience.。',
    view_main_order: 'View main order',
    tracking_parcel: 'Tracking package',
    commodity: 'commodity',
    detail: 'detail',
    operating: 'operating',
    comment_btn: 'Evaluation',
    del_order: 'cancel order',
    buy_again: 'buy again',
    change_payment_method: 'Change payment method',
    view_logistics: 'View Logistics',
    to_pay: 'To pay'
  },
  wish_list: {
    product_name: 'Product name',
    wish_poduct: 'Collection',
    wish_add_car: 'Add to wishlist',
    clear_wish_list: 'Delete all',
    add_to_wish_list_err: 'Add to wishlist fail',
    remote_wish_list_err: 'Remove to wishlist fail',
    confirm_clear_list: 'Are you sure to delete all',
  },
  product: {
    none_specification: 'No specification',
    none_comment: 'No reviews',
    none_advisories: 'No consultation',
    distribution_nonsupport: 'Country or region that does not support distribution',
    id: 'Product ID',
    product: 'Product',
    name: 'Product name',
    product_categories: 'Categories',
    detail: 'Detail',
    price: 'Price',
    old_price: 'Old price',
    unit_price: 'Unit price',
    specification: 'Spec',
    brand: 'Brand',
    unit_tax: 'Tax',
    original_price: 'Original price',
    total: 'Total price',
    quantity: 'Quantity',
    subtotal: 'Subtotal',
    product_details: 'Product detail',
    upc: 'UPC',
    inventory: 'Inventory',
    availability: 'Availability',
    description: 'Product details',
    comment: 'Comment',
    comment_has_number: 'Comment({0})',
    product_name: 'Product name',
    weight: 'Weight',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    specification_and_packaging: 'Product picture',
    advisories: 'Advisories',
    advisories_has_number: 'Advisories({0})',
    comment_time: 'Comment time',
    recovery_time: 'Recovery time',
    let_us_help_you_to_answer_your_doubts: 'Put forward your question, let me help you answer	',
    to_ask_questions: 'Ask',
    question: 'Question',
    answer: 'Answer',
    no_answer: 'No answer',
    advisory_err: 'Advisory fail',
    input_more_than4_words: 'At least 4 words',
    product_list: 'Product list',
    all_categories: 'All categories',
    load_more: 'Load more',
    load_more_error: 'Failed to load the product, please try again later',
    tax_included: 'Tax included',
    stock_inform: 'Arrival Notice',
    more: 'more',
    serve: 'Service',
    serve_content: 'Sold by',
    shipments: 'Shipments',
    source: 'Source',
    delivery: 'Delivery',
    pickup: 'postage',
    pickups: 'No charge for orders up to {price}',
    freight: 'Freight',
    freights: 'Free shipping after order {price}',
    estimated_time: 'Expected to arrive in {time} days',
    authentic_guarantee: 'Authentic guarantee',
    returns: 'Support for return',
    in_stock: 'In stock',
    not_returns: 'Does not support return',
    not_returns_txt: 'This item does not support return and exchange',
    authentic_guarantee_txt: 'OKUBUY promises that the products sold are 100% authentic',
    returns_txt: '7 days after the sale, the quality/missing problem can be applied for after sale, and the product can be returned after the approval.',
    in_stock_txt: 'The goods are in stock and shipped within 48 hours',
    product_upc: 'Commodity UPC',
    coupon: 'Coupon',
    restricted_purchase: 'Restricted purchase',
    hkTo: 'Hong Kong warehouse to ',
  },
  product_list: {
    shop_categories: 'Shop categories',
    price_range: 'Price range',
    filter: 'Filter',
    filter_by_brand: 'Filter by brand ',
    filter_by_source: 'Filter by source',
    list_page_total: 'Total {0} product',
    sort_by: 'Sort by',
    sort_by_index: 'Relevance',
    price: 'Price',
    sort_by_new: 'Time ',
    search_keyword: 'Search for the keyword',
    brand: 'Brand',
    loading_goods: 'Loading more products',
    loading_goods_not: 'No more items',
  },
  shipping_address: {
    add_address: 'Add address',
    consignee: 'Contact name',
    mobile: 'Mobile',
    phone: 'Phone',
    email: 'Email',
    district: 'District',
    zip_code: 'Zip code',
    address: 'Address',
    line1: 'line1',
    line2: 'line2',
    company: 'Company',
    additional_information: 'Additional information',
    set_default: 'Set default',
    confirm_delete: 'Are you sure to delete？',
    deleted: 'Deleted',
    label: 'Address reference name',
    label_placeholder: 'Suggest to use usual name',
    reference_name: 'Reference name',
    my_home: 'Family',
    apartment: 'Apartment',
    parents_home: 'Parents home',
    express_box: 'Express box',
    school: 'School',
    warehouse: 'Warehouse',
    hostel: 'Hostel',
    consignee_placeholder: 'Contact name',
    zip_code_placeholder: 'Zip code',
    email_placeholder: 'Email address',
    company_placeholder: 'Company name',
    mobile_placeholder: 'Mobile',
    area_code: 'Area code',
    phone_placeholder: 'Area code-phone number-extention number',
    select_district: 'Select district',
    address_placeholder: 'Suggest to use detail address',
    additional_information_placeholder: '',
    confirm_close_dialog: 'Are you sure to close？',
    edit_address: 'Edit',
    required_field_no_compltet: '*Required Fields',
    address_has_been_save: 'Address has been save',
    tracking_number: 'Tracking number',
    zipcode: 'zip code',
     rules: {
      label_reduired: 'Please fill in the address label for your convenience',
      consignee_reduired: 'Please fill in the consignee name',
      zipcode_required: 'Please fill in the postal code',
      email_reduired: 'Please fill in the email address',
      email: 'Please fill in the correct email address',
      mobile_reduired: 'Please fill in your phone number',
      selectedDistricts_reduired: 'Please select the area of the shipping address',
      line1_required: 'Please enter your shipping address',
     },
  },
  area: {
    US: 'America',
    France: 'France',
    UK: 'England',
    Germany: 'Germany',
    Malaysia: 'Malaysia',
    Australia: 'Australia',
    NewZealand: 'NewZealand',
    Singapore: 'Singapore',
    Thailand: 'Thailand',
    Japan: 'Japan',
    Korea: 'Korea',
    VietNam: 'VietNam',
    Cambodia: 'Cambodia',
    China: 'CHINA mainland',
    HongKong: 'HONGKONG',
    Macau: 'MACAO',
    TaiWan: 'TAIWAN',
  },
  footer: {
    contacts: 'Contact',
    contact_us: 'Contact us',
    phone: 'Phone',
    monday_friday: 'Monday to Friday',
    customer_service: 'Customer service',
    faq: 'FAQ',
    delivery: 'Delivery',
    payment_method: 'payment method',
    information: 'Information',
    news: 'News',
    terms_and_conditions: 'Terms and conditions',
    privacy_policy: 'Privacy policy',
    about_us: 'About us',
    my_account: 'My account',
    contact_us_me: 'Contact us',
    subscription: 'Subscription',
    show_map: 'Show map 	',
    subscribe: 'Subscription for discount,news,product and propaganda information',
  },
  article: {
    release_time: 'Release time',
    warehousing_and_delivery: 'Warehousing_and_delivery',
    ask_us: 'Need some help?Contact us',
    we_normally_respond: 'We will respond within 2 days',
    your_name: 'Your name',
    category: 'Category',
    question: 'Question',
    placeholder: {
      name: 'Your name',
      category: 'Select question type',
      question: 'Your question',
    },
  },
  home: {
    featured_products: 'Featured Products',
    sale_products: 'Special offer',
    top_sellers: 'Hot Sales',
    new_arrivals: 'New Arrivals',
    recommend_products: 'Recommend Products',
    popular_brands: 'Popular Brands',
    shipping: 'Free shipping',
    shipping_detailed: 'Buy $100 Free Shipping',
    money_back: 'Money-back guarantee',
    money_back_detailed: 'Money-back within 30 days',
    customer_support: '24/7 customer service',
    customer_support_detailed: 'We will respond to you within 24 hours',
    secure_online_payment: 'Secure payment',
    secure_online_payment_detailed: 'Payment with SSL/security certificate',
  },
  cart: {
    add_to_cart: 'Add to cart',
    cart: 'Cart',
    view_cart: 'Check cart',
    price: 'Price',
    checkout: 'Checkout',
    no_login_tips: 'Login to view your cart',
    continue_shipping: 'Continue',
    operation: 'Operation',
    remove: 'Remove',
    add_to_wishlist: 'Add to wishlist',
    added_to_wishlist: 'collected',
    delete_wislist: 'Collection cancelled',
    defeated_delete_wislist: 'Cancel collection failed',
    product_has_been_removed: 'Product has been removed',
    product_has_benn_removed_to_wishlist: 'Product has been removed to wishlist',
    product_move_to_wishlist_and_remove_cart: 'Move item to favorites and remove shopping cart',
    update_to_cart_err: 'Update cart fail',
    empty_cart_tips: 'Your cart is empty',
    total_product: 'Total product',
    total_tax: 'Total tax',
    add_to_cart_err: 'Add to cart fail',
    update_cart_err: 'Change shopping cart failed',
    it_is_cheaper: 'The price is cheaper than before',
    it_is_expensive: 'The price is more expensive than before',
    remove_err: 'Remove failed',
    add_to_cart_success: 'Successfully added to the shopping cart',
  },
  redemption_center: {
    name: 'Name',
    district: 'District',
    address: 'Address',
    phone: 'Phone',
    business_hours: 'Opening hours',
  },
  order_pay: {
    pay_id: 'PAY ID',
    amount: 'Amount',
    pay_time: 'Payment time',
  },
  checkout: {
    product: 'Product',
    unit_price: 'Unit price',
    unit_tax: 'Tax',
    sale_tax: 'Sale tax',
    import_tax: 'Import tax',
    merchandise_news: 'Merchandise news',
    remarks: 'Enter comment information',
    quantity: 'Quantity',
    price: 'Price',
    additional_information: 'Additional information',
    billing_information: 'Billing information',
    shipping_methods: 'Shipping methods',
    self_pick_up: 'Pick up',
    district_only_hk: 'Temporarily only supports delivery to Hong Kong',
    courier: 'Delivery',
    self_point_address: 'Pick up address',
    shipping_address: 'Shipping address',
    add_shipping_address: 'Add shipping address',
    payment_method: 'payment method',
    audit_order: 'Audit order',
    order_created: 'Created order',
    prev: 'Prev',
    next: 'Next',
    back_to_cart: 'Back to cart',
    your_cart_is_empty: 'Your cart is empty',
    go_to_shopping: 'Go to shopping',
    submit_orders: 'Submit',
    picker: 'Picker',
    phone: 'Phone',
    logistics_type: 'Logistics type',
    logistics_fee: 'cost',
    logistics_estimated_time: 'Estimated time',
    logistics_type_1: 'Express service',
    logistics_type_2: 'Special express',
    logistics_type_3: 'Standard service',
    free_postage_tips: 'Tip: Free shipping on orders over {price}',
    free_pick_up_tips: 'Tip: Free shipping fee for orders over {price}',
    area_group_diffent_tips: 'According to your shipping address, the system will automatically settle the currency in the receiving place.',
    consignee_form_validate_error: 'Please fill in the correct recipient information',
    placeholders: {
      name: 'Picker name for pick up',
      phone: 'Pick up password will send to the phone',
    },
    rules: {
       picker_required: 'Please fill in the name of the recipient',
       phone_required: "Please fill in the recipient's phone number, the pickup password will be sent to the mobile phone number",
     },
     checkout_fail: 'Checkout failed',
     get_self_point_address_err: 'Get failed from raising point',
     get_shipping_address_err: 'Failed to get the delivery address',
     please_select_checkout_item: 'Please select the item to be checked out',
     order_split_tips: 'The goods in your order are in different warehouses and need to be split and delivered separately. Please forgive us for any inconvenience. ',
     please_input_promote_code: 'Please enter your offer code',
     promote_code_placeholder: 'Enter the offer code',
    promo_code: 'Promo Code',
    Remote_areas: 'Residential or remote address surcharge of HKD $ 20, which will be charged by the driver. If refusal to pay the residential or remote address surcharge causes delivery failure, the customer will have to pay an additional delivery fee.',
    none: 'none',
    day: 'days',
  },
  shipping_fee: {
    free_postage_condition: 'Free shipping on orders over {price}',
    desc_1: 'Dissatisfied with the additional shipping cost {price}',
    free_pick_up_price: 'Free self-withdrawal fee for over {price}',
    pick_up_price: 'Dissatisfaction with additional self-withdrawal fee {price}',
    desc_2: 'First weight{first_weight}{weight_unit} {first_weight_price}，Continued weight{add_weight}{weight_unit} {add_weight_price}',
    additional_fees: 'additional fees',
    import_tax: 'income tax',
    sale_tax: 'sale tax',
  },
  proxy_request: {
    code: 'Code',
    contact_phone: 'Phone',
    product_name: 'Product',
    product_url: 'Product URL',
    image: 'Image',
    price: 'Price',
    quantity: 'Quantity',
    size: 'Size',
    color: 'Color',
    remark: 'Remark',
    created_at: 'Created at',
    status: 'Status',
    click_upload: 'Upload',
    placeholders: {
      contact_phone: 'We will contact you to confirm proxy product',
      product_name: 'Proxy product name',
      product_url: 'Proxy product URL',
      price: 'Price in HKD',
      size: 'Input detail size',
      color: 'Input detail color',
    },
    rules: {
      contact_phone_required: 'We will contact you to confirm proxy product',
      product_name_required: 'Proxy product name',
      product_url_required: 'Proxy product URL',
      product_url: 'Input correct URL，please use http:// or https://',
      price_required: 'Input product price',
      quantity_required: 'Proxy product quantity',
      shipping_method_required: 'Select shipping method',
      redemption_center_id_required: 'Select redemption center',
      address_id_required: 'Select shipping address',
      payment_method_required: 'Please pay with paypal first',
    },
    please_add_shipping_address: 'Please add the shipping address first',
    not_found: 'Proxy required not found',
    updated: 'Proxy required updated',
    created: 'Proxy required created',
    canceled: 'Your purchase request has been canceled',
    reject: 'Your purchase request was rejected',
    reject_reason: 'reject reason',
    cancel: 'Cancel',
    cancel_tips: 'Are you sure you want to cancel this purchase request? ',
  },
  rakuten: {
    product_detail: 'Rakuten merchandise',
    product_info: 'Product information',
    tax_include: 'including tax',
    view_item_from_rakuten: 'Reading Lotte Page',
    shop_name: 'store name',
    item_code: 'item code',
    category: 'Classification',
    tag: 'tag',
    review_count: 'evaluation number',
    review_count_text: '{0} product reviews',
    review_average: 'Comprehensive evaluation',
    shipping_tips: 'If the goods are contraband or prohibited from being sold overseas, they may not be able to pass customs. We will cancel orders for such items. Please forgive me. ',
  },
  yahoo: {
    product_detail: 'Yahoo merchandise',
    view_item_from_yahoo: 'Read Yahoo Page',
    shop_name: 'store name',
    item_code: 'store code',
    review_count: 'evaluation number',
    review_count_text: '{0} product reviews',
    review_average: 'Comprehensive evaluation',
    category: 'Classification',
    product_info: 'Product information',
    view_review: 'View rating',
    shipping_tips: 'If the goods are contraband or prohibited from being sold overseas, they may not be able to pass customs. We will cancel orders for such items. Please forgive me. ',
  },
  amazon: {
    product_detail: 'Amazon merchandise',
  },
  information: {
    information: 'Information',
    news: 'Latest news',
    terms_and_conditions: 'Terms and conditions',
    privacy_policy: 'Privacy Policy',
    about_us: 'Contact us',
  },
  facebook_pannel: {
    homepage: 'facebook homepage',
    line1: 'Hello our facebook account',
    line2: 'You can learn about the latest news from Okuboy here',
  },
    transportation: {
    parcel_list: 'Package list',
    warehouses: 'Warehouse Address',
    parcel_information: 'Please enter the warehouse address, courier company, tracking number, and shipment information to confirm the shipment',
    parcel_screen: 'Pacing packet filtering',
    goods_name: 'Goods name',
    valuation_fee: 'Insured Cost (HKD)',
    parcel_describe: 'Post package description',
    parcel_status: 'Post parcel status',
    track_num : 'Tracking number',
    ware: 'Warehouse',
    weight_pounds: 'Weight (pounds)',
    courier_tracknum: 'Express company / tracking number',
    new_status: 'Latest state',
    product_details: 'Product details / value',
    push_parcel: 'Active push mail package',
    cancel_record: 'Cancel record',
    completion_information: 'Complete information',
    addgoods: 'Add item',
    send_out: 'send',
    placeholder:{
      choose: 'Please select',
      warehouse_courier: 'Choose warehouse address and courier company',
      status: 'Please select status',
      warehouses: 'Please choose warehouse',
      tracking_num: 'Please enter the tracking number',
    },
   label: {
      warehouse_courier: 'Warehouse address and courier company',
      tracking_num: 'Tracking number',
      unit: 'Unit'
   },
  },
  pickup_point_selector: {
    pickups: 'Self-raising point',
    post_office: 'Post Office',
    address: 'Address',
  },
  validate: {
    mobile: 'Please enter the correct phone number',
    fixline: 'Please enter the correct phone number',
   },
   remove: {
     a: 'Primary Member',
     b: 'Primary promoters',
   },
   payment: {
     paypal: 'PayPal',
     alipay: 'Alipay',
     wechatpay: 'WeChat payment',
     go_to_alipay_website_for_payment: 'Go to Alipay website payment',
     use_alipay_app_scan: "Use Alipay APP' to swipe 'Payment'",
     use_fps_scan: 'QR code payment',
     use_wechat_app_scan: "Use WeChat' to scan 'Payment'",
     pay_with_alipay: 'Alipay payment',
     payment_error: 'Payment encountered an error, please contact customer service. ',
     has_the_payment_been_completed: 'Completed payment? ',
     pay: 'payment',
     checkout_counter: 'Checkout Counter',
     sub_order1: 'Please complete the payment within',
     sub_order2: 'after submitting the order, otherwise the order will be automatically cancelled',

     order_timeout: 'Order payment time has expired',
     order_not_pay: 'This order is currently unpayable',
     order_paid_successful: 'Order paid successfully',
     go_to_alipay_app_for_payment: 'Go to alipay app for payment',
     no_orders: 'No orders',
  },
  comment: {
    order_evaluation: 'Prder evaluation',
    order_number: 'Prder number',
    product_rating: 'Product rating',
    product_review: 'Product review',
    commodity_order: 'Commodity order',
  },
  state: {
    choose_your_country_or_region: 'Choose your country or region',
    africa_middle_east_and_india: 'Africa, Middle East and India',
    asia_pacific: 'Asia-Pacific',
    europe: 'Europe',
    latin_america_and_the_caribbean: 'Latin America and the Caribbean',
    the_united_states_canada_and_puerto_rico: 'United States, Canada and Puerto Rico',
  },
            tracking_statuses: {
     1: 'New order',
     2: 'has arrived at the point of picking up',
     3: 'Send SMS to inform customers to pick up',
     4: 'Guest has picked up',
     10: 'Forecast',
     11: 'Acquisition',
     12: 'In transit',
     13: 'In the piece',
     14: 'Signed',
     15: 'Payment failed',
     16: 'Other',
     17: 'Receive',
     18: 'To the piece',
     19: 'Guest signing',
     20: 'Question piece',
   },
  ...el,
}
